// extracted by mini-css-extract-plugin
module.exports = {"link":"_2aAHb","root":"D1vc6","label":"s1Ga0"};